import { ReactElement, useState, useEffect } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { personalPlans } from './data/plans';
import { NewPlanCard } from './NewPlanCard';

export default function IndividualPlansCarousel(): ReactElement {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    loop: true,
    slides: {
      perView: 1,
      spacing: 16,
    },
    breakpoints: {
      '(min-width: 768px)': {
        slides: { perView: 2, spacing: 24 },
      },
      '(min-width: 1200px)': {
        slides: { perView: 4, spacing: 10 },
      },
    },
    slideChanged(s) {
      setCurrentSlide(s.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  // Autoplay setup
  useEffect(() => {
    const interval = setInterval(() => {
      if (slider) {
        slider.current?.next();
      }
    }, 3000); // Change slide every 3 seconds

    return () => {
      clearInterval(interval);
    };
  }, [slider]);

  return (
    <div className="relative">
      <div ref={sliderRef} className="keen-slider" style={{ padding: '16px' }}>
        {personalPlans.map((plan, index) => (
          <div
            key={index}
            className="keen-slider__slide"
            style={{ padding: '8px' }}
          >
            <NewPlanCard plan={plan} type="individual" />
          </div>
        ))}
      </div>

      {/* Slide indicators */}
      {loaded && slider && (
        <div className="flex justify-center mt-4">
          {[...Array(slider.current?.track?.details?.slides.length || 0)].map(
            (_, idx) => (
              <button
                key={idx}
                onClick={() => {
                  slider.current?.moveToIdx(idx);
                }}
                className={`mx-1 w-2 h-2 rounded-full transition-all ${
                  currentSlide === idx ? 'bg-blue-500 w-4' : 'bg-gray-300'
                }`}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ),
          )}
        </div>
      )}
    </div>
  );
}
